import { styled } from "@linaria/react";
import { logEvent } from "../../utils";
import { COLOR_BLACK, COLOR_BLUE_LIGHT } from "../../constants";
import { GitHub, LinkedIn, TwitterIcon } from "../icons";
export const MediaLink = /*#__PURE__*/styled("a")({
  name: "MediaLink",
  class: "m1sgx1iy"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1kd1wia"
});

function MediaLinks(): JSX.Element {
  return <Container>
      <MediaLink href="https://twitter.com/fiberplane" onClick={event => {
      event.preventDefault();
      logEvent("button:click", "twitter", "social-media-links");
      const url = event.currentTarget.getAttribute("href");

      if (url) {
        setTimeout(() => window.location.href = url, 100);
      }
    }}>
        <TwitterIcon height="60" />
      </MediaLink>
      <MediaLink href="https://www.linkedin.com/company/fiberplane/" onClick={event => {
      event.preventDefault();
      logEvent("button:click", "linkedin", "social-media-links");
      const url = event.currentTarget.getAttribute("href");

      if (url) {
        setTimeout(() => window.location.href = url, 100);
      }
    }}>
        <LinkedIn height="60" />
      </MediaLink>
      <MediaLink href="https://github.com/fiberplane/" onClick={event => {
      event.preventDefault();
      logEvent("button:click", "twitter", "social-media-links");
      const url = event.currentTarget.getAttribute("href");

      if (url) {
        setTimeout(() => window.location.href = url, 100);
      }
    }}>
        <GitHub height="60" />
      </MediaLink>
    </Container>;
}

export default MediaLinks;

require("../../../.linaria-cache/src/components/mediaLinks/index.linaria.module.css");